<template>
<div>
  <Top />
  <div class="maindiv zcollege-wrap bg-gray" v-if="info.school">
    <Banner :is-detail="true" :info="info.school"/>
    <div class="zcdetail mt20 bgw htmldiv">
      <div class="cont fs16 tc6 lh20">
        <div class="sdiv">
          <div class="fs24 btt prelative green pl25 lh10">学院简介</div>
          <div class="pt40 pb40 pl15 pr30" v-html="info.school.detail">
          </div>
        </div>
        <div class="sdiv">
          <div class="fs24 btt prelative green pl25 lh10">招生专业</div>
          <div class="dislist pl15 pt40 pb40">
            <EnItem v-for="(item,index) in info.majors" :key="index" :index="index" :item="item"/>
          </div>
        </div>
        <div class="sdiv">
          <div class="fs24 btt prelative green pl25 lh10">证书</div>
          <div class="pt40 pb40 pl15">
            <img v-for="(item,index) in info.certificates" :src="item.image" alt="" width="430" height="325" :key="index">
          </div>
        </div>
      </div>
    </div>
  </div>
  <Bottom />
</div>
</template>

<script>
import Top from "../top";
import Banner from "../bannerbf";
import Bottom from "../bottom";
import BannerTitle from "./ttitle";
import EnItem from "./en-item";
export default {
  name: "detail",
  data () {
    return {
      'info':{},
    }
  },
  components:{
    Top,
    Banner,
    Bottom,
    BannerTitle,
    EnItem,
  },
  created() {
    var id = this.$route.query.id;
    var getParam = {};
    getParam['id'] = id;
    this.$request.get('school/detail',getParam,response => {
      if(response.status == 200){
        this.info = response.data.data;
        // document.title = this.info.school.name;
      }
    },error => {
      console.log(error);
    })
  }
}
</script>

<style scoped>
  .zcdetail{padding: 35px 40px 10px;}
  .btt::before{content: '';position: absolute;left: 0;top: 0;bottom: -2px;margin-right: 25px;width: 4px;}
  .btt.green::before{background: #3a8c39}
</style>



// WEBPACK FOOTER //
// src/components/hedu/school/detail.vue